import axios from 'axios';

import * as urls from '../constants/urls';

export const postOPDHandler = ({ payload }) => (
    axios.post(urls.OPD_SUBMIT.stringify(), payload)
);

export const getUserLinkHandler = ({ payload: params }) => (
    axios.get(urls.OPD_USERLINK.stringify(), { params })
);

export const postCancelOpdHandler = ({ payload }) => (
    axios.post(urls.CANCEL_OPD.stringify(), payload)
);
